"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initEventGateway = void 0;
/*
 * Initializes a gateway which can produce events to the given emitter. The gateway is running
 * when there are any listeners for the given eventName: the start() callback is called
 * when a first event listener for the event name is added, and the stop() callback is called
 * when the last event listener is removed.
 */
const initEventGateway = (eventName, start, stop, emitter) => {
    const observer = emitter.getObserver();
    const emit = (payload) => emitter.emit(eventName, payload);
    let producer;
    observer.on('addEventListener', (sourceEvent) => {
        if ((sourceEvent === eventName) && (producer === undefined)) {
            producer = start(emit);
        }
    });
    observer.on('removeEventListener', (sourceEvent) => {
        if ((sourceEvent === eventName) && (producer !== undefined) && (emitter.getListenerCount(eventName) === 0)) {
            stop(producer);
            producer = undefined;
        }
    });
    if (emitter.getListenerCount(eventName) > 0) {
        producer = start(emit);
    }
};
exports.initEventGateway = initEventGateway;
//# sourceMappingURL=initEventGateway.js.map